import { Columns } from '#types/grid';

export function getAvailableColumns(columns: Columns): Columns {
  const availableColumns: Columns = [];

  for (const column of columns) {
    if (!column.visible) {
      availableColumns.push(column);
    }
  }

  return [...availableColumns];
}
